import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ o("path", { d: "M8.518 2.471a.76.76 0 0 0-.5-.191.75.75 0 0 0-.273.053.702.702 0 0 0-.228.147L3.723 5.617a.627.627 0 0 0-.207.46c0 .173.074.339.207.461a.74.74 0 0 0 .5.19.74.74 0 0 0 .5-.19l3.294-2.685 3.255 2.685a.74.74 0 0 0 .5.19.74.74 0 0 0 .501-.19.654.654 0 0 0 .157-.213.607.607 0 0 0 0-.504.654.654 0 0 0-.157-.213L8.518 2.471ZM7.483 13.345a.76.76 0 0 0 .5.191.75.75 0 0 0 .273-.053.702.702 0 0 0 .228-.147l3.794-3.136a.627.627 0 0 0 .207-.46.627.627 0 0 0-.207-.461.74.74 0 0 0-.5-.191.74.74 0 0 0-.501.19l-3.294 2.685L4.728 9.28a.74.74 0 0 0-.5-.191.74.74 0 0 0-.5.19.652.652 0 0 0-.157.213.607.607 0 0 0 0 .505c.036.08.09.152.156.213l3.756 3.136Z" }, null, -1), c = [
  a
];
function l(r, s) {
  return e(), t("svg", n, [...c]);
}
const _ = { render: l };
export {
  _ as default,
  l as render
};
